import Vue from "vue";
import Router from "vue-router";
const Home = () => import(/* webpackChunkName: "Home" */ "./views/Home.vue");

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "About" */ "./views/About.vue")
    },
    {
      path: "/c/:id",
      name: "projects",
      component: () =>
        import(/* webpackChunkName: "Projects" */ "./views/Projects.vue")
    },
    {
      path: "/shop",
      name: "shop",
      component: () => import(/* webpackChunkName: "Shop" */ "./views/Shop.vue")
    },
    {
      path: "/shop/:id",
      name: "shop-item",
      component: () =>
        import(/* webpackChunkName: "ShopItemView" */ "./views/ShopItemView.vue")
    },
    {
      path: "/collections/",
      name: "collections",
      component: () => import(/* webpackChunkName: "Shop" */ "./views/Collections.vue")
    },
    {
      path: "/collections/:id",
      name: "collection",
      component: () =>
        import(/* webpackChunkName: "ShopItemView" */ "./views/Collection.vue")
    },
    {
      path: "/textiles/",
      name: "textiles",
      component: () => import(/* webpackChunkName: "Shop" */ "./views/Collections.vue")
    },
    {
      path: "/textiles/:id",
      name: "textile",
      component: () =>
        import(/* webpackChunkName: "ShopItemView" */ "./views/Collection.vue")
    },
    {
      path: "/order-complete/:id",
      name: "order-complete",
      props: true,
      component: () =>
        import(/* webpackChunkName: "OrderComplete" */ "./views/OrderComplete.vue")
    },
    {
      path: "/terms-conditions",
      name: "conditions",
      component: () =>
        import(/* webpackChunkName: "Conditions" */ "./views/Conditions.vue")
    },
    {
      path: "/privacy-policy",
      name: "policy",
      component: () =>
        import(/* webpackChunkName: "Policy" */ "./views/Policy.vue")
    },
    {
      path: "/stockist",
      name: "stockist",
      component: () =>
        import(/* webpackChunkName: "Stockist" */ "./views/Stockist.vue")
    },
    {
      path: "/masque",
      name: "masque",
      component: () =>
        import(/* webpackChunkName: "Masque" */ "./views/Masque.vue")
    },
    {
      path: "/head-masque",
      name: "head-masque",
      component: () =>
        import(/* webpackChunkName: "Head Masque" */ "./views/HeadMasque.vue")
    },
    {
      path: "/size-guide",
      name: "size-guide",
      component: () =>
        import(/* webpackChunkName: "SizeGuide" */ "./views/SizeGuide.vue")
    },
    {
      path: "/success",
      name: "success",
      component: () =>
        import(/* webpackChunkName: "Success" */ "./views/Success.vue")
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});
